import * as React from "react"
import { graphql } from "gatsby"
import Gallery from "../../components/Gallery/Gallery"
import { normalizeImageProps } from "../utils/image"

const PrismicPageDataBodyGallery = ({ items }) => {
  const images = items.map(item => normalizeImageProps(item?.image))

  return (
    <Gallery images={images}/>
  )
}

export const query = graphql`
    fragment Gallery on PrismicPageDataBodyGallery {
        slice_type
        slice_label
        __typename
        items {
            image {
                alt
                gatsbyImageData(width: 800, placeholder: BLURRED)
            }
        }
    }
`

export default PrismicPageDataBodyGallery;
